export default __webpack_public_path__ + "static/media/char-finn.a2cf515c.jpg";